import script from "./AddCust.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCust.vue?vue&type=script&setup=true&lang=js"

import "./AddCust.vue?vue&type=style&index=0&id=fc3a5938&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc3a5938"]])

export default __exports__